import "react-phone-number-input/style.css";

import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import PhoneForm from "@/features/profile/components/PhoneForm";
import { ProfileAttributePage, useProfileAttributePage } from "@/features/profile/components/ProfileAttributePage";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

const Phone = () => {
    const { auth, copy, goToProfile } = useProfileAttributePage();
    const { data: profile } = useSuspenseQuery(selectProfileByIdQueryOptions(auth.id));

    return (
        <ProfileAttributePage title={copy.onboardingPhoneTitle} description={copy.onboardingPhoneDescription}>
            <PhoneForm
                userId={auth.id}
                phone={profile?.phone ?? ""}
                onBack={goToProfile}
                onSuccess={goToProfile}
                primaryLabel={copy.save}
            />
        </ProfileAttributePage>
    );
};

export const Route = createFileRoute("/_app/profile/phone")({
    component: Phone,
});
